import React from 'react';
import { Button, Grid } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { useSelector } from 'react-redux';
import LeaderboardAddNewPopup from './LeaderboardAddNewPopup';

const useStyles = makeStyles(() => ({
  addressHeading: {
    textAlign: 'left',
    fontWeight: 600,
    fontSize: '14px',
    lineHeight: '17px',
    fontStyle: 'normal',
    color: 'rgba(0, 0, 0, 0.4)',
    marginBottom: 0,
  },
  addressText: {
    wordBreak: 'break-all',
    textAlign: 'left',
    fontWeight: 500,
    fontSize: '12px',
    lineHeight: '21px',
    fontStyle: 'normal',
    color: 'black',
    marginTop: '5px',
  },
  container: {
    overflow: 'auto',
    width: '281px',
    '&::-webkit-scrollbar': { width: '10px' },
    '&::-webkit-scrollbar-track': {
      boxShadow: 'inset 0 0 5px grey',
      borderRadius: '20px',
    },
    '&::-webkit-scrollbar-thumb': {
      background: 'lightGrey',
      borderRadius: '100px',
    },
  },
  editButton: {
    height: '35px',
    marginRight: '10px',
  },
  editDiv: {
    marginTop: '20px',
  },
}));

const LeftSideLeaderboard = (props) => {
  const classes = useStyles();
  // const selectedId = useSelector((state) => state?.getLeaderboard?.selectedLeaderboard);
  const overview = useSelector((state) => state?.getLeaderboard.leaderboardOverview);
  const [isAddnewPopupOpen, setisAddnewPopupOpen] = React.useState(false);

  const closeAddNewDealership = () => {
    setisAddnewPopupOpen(false);
  };

  return (
    <>
      <section className={props.customStyles}>
        <Grid
          className={classes.container}
          container
          direction="column"
          justifyContent="flex-start"
          alignItems="flex-start"
        >
          <Grid item>
            <p className={classes.addressHeading}>NAME</p>
            <p className={classes.addressText}>{overview.name}</p>
          </Grid>
          <Grid item>
            <p className={classes.addressHeading}>START DATE</p>
            <p className={classes.addressText}>{overview.startDate}</p>
          </Grid>
          <Grid item>
            <p className={classes.addressHeading}>END DATE</p>
            <p className={classes.addressText}>{overview.endDate}</p>
          </Grid>
          <Grid item>
            <p className={classes.addressHeading}>TIMEZONE</p>
            <p className={classes.addressText}>{overview.timezone}</p>
          </Grid>
          <Grid item>
            <p className={classes.addressHeading}>TYPE</p>
            <p className={classes.addressText}>{overview.type}</p>
          </Grid>
          <Grid item>
            <p className={classes.addressHeading}>STATUS</p>

            <p className={classes.addressText}>{overview.enabled ? 'Enabled' : 'Disabled'}</p>
          </Grid>
        </Grid>
      </section>
      <div className={classes.editDiv}>
        <Button
          variant="contained"
          color="primary"
          focusRipple={false}
          onClick={() => {
            setisAddnewPopupOpen((flag) => !flag);
          }}
          className={classes.editButton}
        >
          Edit
        </Button>
      </div>
      {isAddnewPopupOpen && <LeaderboardAddNewPopup close={closeAddNewDealership} leaderboardId={overview?.id} />}
    </>
  );
};

export default LeftSideLeaderboard;
